/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {LicenseInfo} from '../models/LicenseInfo';

export interface GetAccountLicenseHistory$Request {
    accountId: number;
}

export interface GetAccountLicenseHistory$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountLicenseHistoryRequest = createAction<PayloadData<void, GetAccountLicenseHistory$Request>>('GET_ACCOUNT_LICENSE_HISTORY__GET_ACCOUNT_LICENSE_HISTORY__REQUEST');
export const getAccountLicenseHistorySuccess = createAction<PayloadData<Array<LicenseInfo>, GetAccountLicenseHistory$Request>>('GET_ACCOUNT_LICENSE_HISTORY__GET_ACCOUNT_LICENSE_HISTORY__SUCCESS');
export const getAccountLicenseHistoryFailure = createAction<PayloadData<Error, GetAccountLicenseHistory$Request, true>>('GET_ACCOUNT_LICENSE_HISTORY__GET_ACCOUNT_LICENSE_HISTORY__FAILURE');

export const getAccountLicenseHistoryActions = [
    getAccountLicenseHistoryRequest,
    getAccountLicenseHistorySuccess,
    getAccountLicenseHistoryFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountLicenseHistory = (meta: GetAccountLicenseHistory$Request, config?: GetAccountLicenseHistory$Config) => {
    return {
        CALL_API: {
            types: getAccountLicenseHistoryActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/licenses/history`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

